// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2qiK_","addWidgetButton":"Header_addWidgetButton__3cDwG","dashboardTabs":"Header_dashboardTabs__2kKRM","active":"Header_active__3qGkW"};